module.exports = __webpack_public_path__ + "img/koala_tech_s.236f72c8.png";